module.exports = __webpack_public_path__ + "static/media/BrixSans-Regular.aae64e07.eot";